import { render, staticRenderFns } from "./SpellingInterractExe.vue?vue&type=template&id=38b5ee91&"
import script from "./SpellingInterractExe.vue?vue&type=script&lang=ts&"
export * from "./SpellingInterractExe.vue?vue&type=script&lang=ts&"
import style0 from "./SpellingInterractExe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports